<div [id]="id" [hidden]="!active" role="tabpanel" [attr.aria-hidden]="!active" [attr.aria-labelledby]="id + '-tab'">
  <ng-content></ng-content>
</div>
